import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import RepresentantesModal from './RepresentantesModal';
import RepresentativeResultsModal from './RepresentativeResultsModal';
import RepresentativeFollowup from './RepresentativeFollowup';

export default function UnitRepresentativePanel() {
  return <div className="p-3"><h3>Representantes desta unidade</h3>
    <Tabs defaultActiveKey="list" mountOnEnter unmountOnExit className="mb-3">
      <Tab eventKey="list" title="Listagem"><RepresentantesModal show embedded /></Tab>
      <Tab eventKey="results" title="Resultados"><RepresentativeResultsModal embedded /></Tab>
      <Tab eventKey="followup" title="Retornos"><RepresentativeFollowup /></Tab>
    </Tabs>
  </div>;
}
